<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9237 5.76655C11.8165 5.61991 9.26224 2.17578 5.99994 2.17578C2.73765 2.17578 0.183235 5.61991 0.0761486 5.76641C-0.0253829 5.90554 -0.0253829 6.09423 0.0761486 6.23336C0.183235 6.38001 2.73765 9.82413 5.99994 9.82413C9.26224 9.82413 11.8165 6.37999 11.9237 6.23348C12.0254 6.09438 12.0254 5.90554 11.9237 5.76655ZM5.99994 9.03293C3.59691 9.03293 1.51564 6.74699 0.899533 5.99969C1.51484 5.25173 3.59176 2.96699 5.99994 2.96699C8.40285 2.96699 10.484 5.25252 11.1004 6.00023C10.485 6.74817 8.40813 9.03293 5.99994 9.03293Z"
      fill="#A8A5A5"
    />
    <path
      d="M5.99961 3.62646C4.69081 3.62646 3.62598 4.6913 3.62598 6.0001C3.62598 7.3089 4.69081 8.37374 5.99961 8.37374C7.30841 8.37374 8.37325 7.3089 8.37325 6.0001C8.37325 4.6913 7.30841 3.62646 5.99961 3.62646ZM5.99961 7.58251C5.12703 7.58251 4.4172 6.87266 4.4172 6.0001C4.4172 5.12755 5.12706 4.41769 5.99961 4.41769C6.87217 4.41769 7.58202 5.12755 7.58202 6.0001C7.58202 6.87266 6.87219 7.58251 5.99961 7.58251Z"
      fill="#A8A5A5"
    />
  </svg>
</template>
